import { render } from "./ThreadView.vue?vue&type=template&id=10981bc6&scoped=true"
import script from "./ThreadView.vue?vue&type=script&lang=js"
export * from "./ThreadView.vue?vue&type=script&lang=js"

import "./ThreadView.vue?vue&type=style&index=0&id=10981bc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10981bc6"]])

export default __exports__